import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api.js';

export default function ForgotPassword() {
  const nav = useNavigate();
  const [insts, setInsts] = useState([]);
  const [form, setForm] = useState({ institution_id: '', username: '', recovery_code: '' });
  const [err, setErr] = useState('');
  const [result, setResult] = useState(null);

  useEffect(() => { api.institutions().then(setInsts); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setResult(null);
    try {
      const r = await api.forgot({
        institution_id: Number(form.institution_id),
        username: form.username.trim(),
        recovery_code: form.recovery_code.trim().toUpperCase(),
      });
      setResult(r);
    } catch (e) { setErr(e.message); }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 py-10 bg-gradient-to-b from-white to-medical-50">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-card p-7 border border-medical-100">
        <h1 className="text-xl font-bold text-medical-800 mb-1">비밀번호 찾기</h1>
        <p className="text-sm text-medical-500 mb-5">발급된 복구코드를 입력하면 임시 비밀번호가 발급됩니다.</p>
        {!result ? (
          <form onSubmit={submit}>
            <label className="text-sm font-semibold text-medical-700">소속 기관</label>
            <select className="w-full mt-1 mb-3 px-3 py-2 border border-medical-200 rounded-md"
              value={form.institution_id} onChange={e => setForm({ ...form, institution_id: e.target.value })} required>
              <option value="">선택하세요</option>
              {insts.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
            </select>
            <label className="text-sm font-semibold text-medical-700">아이디</label>
            <input className="w-full mt-1 mb-3 px-3 py-2 border border-medical-200 rounded-md"
              value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required />
            <label className="text-sm font-semibold text-medical-700">복구코드</label>
            <input className="w-full mt-1 mb-4 px-3 py-2 border border-medical-200 rounded-md uppercase tracking-widest"
              value={form.recovery_code} onChange={e => setForm({ ...form, recovery_code: e.target.value })} required />
            {err && <div className="text-sm text-red-600 mb-3">{err}</div>}
            <button className="w-full bg-medical-600 hover:bg-medical-700 text-white font-semibold py-2.5 rounded-md">
              임시 비밀번호 발급
            </button>
            <div className="text-center text-sm mt-3">
              <Link to="/login" className="text-medical-600 hover:underline">로그인으로 돌아가기</Link>
            </div>
          </form>
        ) : (
          <div>
            <div className="text-sm text-medical-700 mb-2">{result.message}</div>
            <div className="bg-medical-50 border border-medical-100 rounded-md p-3">
              <div className="text-xs text-medical-500">임시 비밀번호</div>
              <div className="text-lg font-mono font-bold text-medical-800 tracking-wider">{result.temp_password}</div>
            </div>
            <button onClick={() => nav('/login')}
              className="mt-4 w-full bg-medical-600 hover:bg-medical-700 text-white font-semibold py-2.5 rounded-md">
              로그인 화면으로 이동
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
